/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import CloseIcon from '@toucan/client/global/icons/legacy/cross.svg';

import {
    IconButton,
    IconButtonFill,
    IconButtonSize,
} from '@toucan/client/shared/components/icon-button';

import { styles } from './sitewide-banner.styles';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum SitewideBannerColours {
    SOL = 'sol',
    FLAME = 'flame',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface SitewideBannerProps {
    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * Colour theme of the sitewidebanner
     * @default FLAME
     */
    colour?: SitewideBannerColours;

    /**
     * onClose handler
     */
    onClose?: () => void;
}

const StyledSitewideBanner = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const SitewideBanner: FunctionComponent<SitewideBannerProps> = ({
    children,
    onClose,
    colour = SitewideBannerColours.FLAME,
    ...otherProps
}: SitewideBannerProps) => {
    return (
        <StyledSitewideBanner colour={colour} {...otherProps}>
            <div className="sitewide-banner-content">{children}</div>
            {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
            {onClose && (
                <IconButton
                    label={'Close banner'}
                    size={IconButtonSize.LARGE}
                    border={true}
                    fill={IconButtonFill.HOLLOW}
                    onClick={onClose}
                    data-testid="sitewide-banner-close-button"
                    className="sitewide-banner-close"
                >
                    <CloseIcon />
                </IconButton>
            )}
        </StyledSitewideBanner>
    );
};
